import { ShieldCheck } from "lucide-react";
import { Section, Kicker, Reveal } from "./primitives";

export const Garantia = () => (
  <Section id="garantia">
    <Reveal>
      <Kicker num="07" label="Garantía de riesgo cero" />
    </Reveal>
    <Reveal delay={0.1}>
      <div className="flex flex-col items-center gap-9 rounded-3xl border border-amber-400/30 bg-gradient-to-br from-[#141B2C] to-[#0B1322] p-8 sm:p-12 md:flex-row">
        <div className="flex h-32 w-32 shrink-0 flex-col items-center justify-center rounded-full border-2 border-amber-400 shadow-[0_0_60px_rgba(245,158,11,0.28)]">
          <span className="font-display text-5xl font-extrabold leading-none text-amber-300">7</span>
          <span className="mt-1 font-tech text-[10px] tracking-[0.35em] text-amber-200/80">DÍAS</span>
        </div>
        <div>
          <h3 className="flex items-center gap-3 font-display text-xl font-bold text-slate-50 sm:text-2xl">
            <ShieldCheck className="h-6 w-6 shrink-0 text-amber-400" />
            Garantía incondicional respaldada por Hotmart
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-slate-400 sm:text-base">
            Entra al programa, participa en las primeras clases, descarga las plantillas y
            revisa todo el material técnico. Si dentro de los primeros 7 días sientes que
            este entrenamiento no transforma tu capacidad técnica, solicitas el reembolso
            directamente en la plataforma. Te devolvemos el 100% de tu dinero, sin
            preguntas ni trámites incómodos. Todo el riesgo corre por nuestra cuenta.
          </p>
        </div>
      </div>
    </Reveal>
  </Section>
);
